<template>
    <div>
        <div class="acctitle flx alc jsb">
            <div class="actleft">
                <el-button type="primary" @click="toAdd">+ 发布服务</el-button>
            </div>
            <div class="acRight flx alc" :style="info.level == 2?'visibility:hidden' : ''">
                <div class="acrtips">
                    为了不影响您活动报名、提现和管理，请及时认证
                </div>
                <el-button type="primary" @click="toConfirm">立即认证</el-button>
            </div>
        </div>
        <el-tabs ref="tabRef" v-model="activeName" @tab-click="handleClick">
            <el-tab-pane :label="num1 > 0?`在线中·${num1}` : '在线中'" name="0">
                <List @getNums="getnums" :type="0" v-if="activeName == 0"></List>
            </el-tab-pane>
            <el-tab-pane :label="num2 > 0?`未上线·${num2}` : '未上线'" name="1">
                <List @getNums="getnums" :type="1" v-if="activeName == 1"></List>
            </el-tab-pane>
            <el-tab-pane :label="num3 > 0?`审核中·${num3}` : '审核中'" name="2">
                <List @getNums="getnums" :type="2" v-if="activeName == 2"></List>
            </el-tab-pane>
            <!-- 标题固定文字，红点JS动态挂载 -->
            <el-tab-pane label="未过审" name="3">
                <List @getNums="getnums" :type="3" @rfh="refreshs" v-if="activeName == 3"></List>
            </el-tab-pane>
            <el-tab-pane :label="num5 > 0?`草稿箱·${num5}` : '草稿箱'" name="4">
                <List @getNums="getnums" :type="4" v-if="activeName == 4"></List>
            </el-tab-pane>
        </el-tabs>
        <div v-if="showLogin">
            <Login @cal="showLogin = false"></Login>
        </div>
    </div>
</template>
<script>
    import {
        shoUserInfo
    } from "@/api/index.js"
    import Login from '@/components/login.vue'
    import List from './list.vue'
    export default {
        name: 'Shops',
        components: {
            Login,
            List
        },
        data() {
            return {
                activeName: '0',
                info: {
                    level: 2
                },
                num1: 0,
                num2: 0,
                num3: 0,
                num4: 0,
                num5: 0,
                showLogin: false
            };
        },
        mounted() {
            this.getUserinfo()
            this.$nextTick(() => {
                this.updateBadgeDot()
            })
        },
        methods: {
            refreshs(){
                this.$emit('rfh')
            },
            getnums(e) {
                console.log("emit", e)
                this.num1 = e[0]
                this.num2 = e[1]
                this.num3 = e[2]
                this.num4 = e[3]
                this.num5 = e[4]
                this.$nextTick(() => {
                    this.updateBadgeDot()
                })
            },
            updateBadgeDot() {
                if (!this.$refs.tabRef) return
                const tabsNavItems = this.$refs.tabRef.$refs.nav.$el.querySelectorAll('.el-tabs__item')
                const targetTabItem = tabsNavItems[3]
                if (!targetTabItem) return

                const oldDot = targetTabItem.querySelector('.custom-tab-badge')
                if (oldDot) oldDot.remove()

                if (this.num4 > 0) {
                    const dot = document.createElement('span')
                    dot.className = 'custom-tab-badge'
                    targetTabItem.style.position = 'relative'
                    targetTabItem.appendChild(dot)
                }
            },
            getUserinfo() {
                let that = this
                shoUserInfo().then((res) => {
                    console.log("333", res)
                    if (res.code == 1) {
                        that.info = res.data
                    } else if (res.code == -2) {
                        this.$message.error(res.msg)
                        this.showLogin = true
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            },
            handleClick(tab) {
                console.log(tab);
                this.$nextTick(() => this.updateBadgeDot())
            },
            toAdd() {
                this.$router.push('/addService')
            },
            toConfirm() {
                this.$router.push('/verify')
            }
        }
    }
</script>
<style scoped>
    .liMiddle {
        margin-left: 86px;
    }

    .liEdit {
        font-size: 16px;
        color: #007AFF;
    }

    .liDes {
        font-size: 14px;
        color: #999999;
        text-align: left;
    }

    .liTop {
        font-weight: 500;
        font-size: 20px;
        color: #222222;
        line-height: 28px;
        margin-bottom: 4px;
    }

    .liName {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 16px;
        text-align: left;
    }

    .liDes {
        font-size: 14px;
        color: #555C70;
    }

    .listItem {
        box-sizing: border-box;
        padding: 20px 30px;
        border-radius: 10px;
        border: 1px solid #D9D9D9;
        margin-bottom: 20px;
    }

    .lists {
        box-sizing: border-box;
        padding: 0 30px 0;
    }

    .acctitle {
        box-sizing: border-box;
        padding: 28px 30px 0;
    }

    ::v-deep .custom-tab-badge {
        position: absolute;
        top: 12px;
        right: 8px;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #f56c6c;
    }
</style>